import axiosClient from "./axios";

/**
 * Kullanıcının numeroloji bilgilerini getirir
 * @returns {Promise} Numeroloji verisi
 */
export const getNumerologyData = async () => {
  try {
    const response = await axiosClient.get("/module/numerology");
    return response.data;
  } catch (error) {
    console.error("Numeroloji verisi alınırken hata:", error);
    throw error;
  }
};

